import React from "react";
import { Star } from "lucide-react";

/** Read-only star row */
export const StarRating = ({ value = 0, size = 14, className = "" }) => {
  const filled = Math.round(value);
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= filled ? "text-[#1565FF] fill-[#1565FF]" : "text-[#2A2A2A] fill-[#171717]"}
        />
      ))}
    </div>
  );
};

/** Interactive selector used in the review form */
export const StarSelector = ({ value, onChange, size = 22 }) => {
  const [hover, setHover] = React.useState(0);
  return (
    <div
      className="inline-flex items-center gap-1"
      onMouseLeave={() => setHover(0)}
      data-testid="review-form-star-selector"
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          onMouseEnter={() => setHover(i)}
          onClick={() => onChange(i)}
          data-testid={`review-form-star-${i}`}
          className="p-1 rounded-full hover:bg-[#171717] transition-colors"
          aria-label={`Rate ${i} out of 5`}
        >
          <Star
            size={size}
            className={
              i <= (hover || value)
                ? "text-[#1565FF] fill-[#1565FF]"
                : "text-[#2A2A2A] fill-[#171717]"
            }
          />
        </button>
      ))}
    </div>
  );
};
